import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreLegacyTimelineDetailsGetAsyncSlice } from './get';

export const coreLegacyTimelineDetailsReducers = combineReducers({
	get: coreLegacyTimelineDetailsGetAsyncSlice.asyncReducers
});

export const coreLegacyTimelineDetailsWatchers = combineAllWatchers([ coreLegacyTimelineDetailsGetAsyncSlice.asyncWatchers ]);
